
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 973.2 973.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M924 828.8V315.5c-3.6.3-7.2.5-10.8.5H60c-3.6 0-7.3-.2-10.8-.5v513.1a60 60 0 0060 60H864a60 60 0 0060-60zM687 513.4a30 30 0 01-30 30H316.2a30 30 0 01-30-30v-79.6a30 30 0 0130-30h340.7a30 30 0 0130 30v79.5h.1zm286.2-317.3v-51.7a60 60 0 00-60-60H60a60 60 0 00-60 60v51.7a60 60 0 0060 60h853.1a60 60 0 0060.1-60z"}})])
          )
        }
      }
    